import signals from '../lib/signals.js';

export class StudentAttendancePresentModel {
	constructor() {
		this.sams = [];
		this.Listeners = new signals.Signal();
	}
	addStudentAttendanceModel(sam) {
		this.sams.push(sam);
		sam.changed.add( (evt)=> {
			this.Listeners.dispatch(this);
		});
		this.Listeners.dispatch();
	}
	count() {
		let present = 0;
		for (let s of this.sams) {
			if (s.isPresent()) {
				present++;
			}
		}
		return present;
	}
}